import { APIStatus } from '@application/common/enums/api-status';
import { addAttachmentsByCreditorIdAsync, createContactPersonAsync, createCreditureAsync, deleteContactPersonByIdAsync, deleteCreditorAttachmentAsync, getAllAttachmentsByCreditorIdAsync, getAllCreditorsAsync, getAllExternCrediteurAsync, getAllInternCrediteurAsync, getContactPersonbyIdAsync, getContactPersonsByCreditorIdAsync, getCreditureByIdAsync, getCreditureNumberAsync, updateContactPersonAsync, updateCreditureAsync, deleteCreditureByIdAsync, updateCreditorToPreferenceAsync } from './creditureThunk';
import { createSlice } from '@reduxjs/toolkit';
import { AppConsts } from '@application/common/constants/app-consts';
const internCreditureRequest = {
    pageNumber: AppConsts.GRID_DEFAULT_PAGE_NUMBER,
    pageSize: AppConsts.GRID_DEFAULT_PAGE_SIZE
};
const externCreditureRequest = {
    pageNumber: AppConsts.GRID_DEFAULT_PAGE_NUMBER,
    pageSize: AppConsts.GRID_DEFAULT_PAGE_SIZE
};
const initialState = {
    status: APIStatus.IDLE,
    internCreditureRequest: internCreditureRequest,
    externCreditureRequest: externCreditureRequest
};
export const creditureSlice = createSlice({
    name: 'crediture',
    initialState,
    reducers: {
        clearSingleCrediture: (state) => {
            state.contactPersoon = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCreditureNumberAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getCreditureNumberAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.creditureNumber = action.payload;
        })
            .addCase(getCreditureNumberAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createCreditureAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createCreditureAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.crediture = action.payload;
        })
            .addCase(createCreditureAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateCreditureAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateCreditureAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.updateCrediture = action.payload;
            state.unchangedCreditor = action.payload;
        })
            .addCase(updateCreditureAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllInternCrediteurAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllInternCrediteurAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.internCreditures = action.payload;
        })
            .addCase(getAllInternCrediteurAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllExternCrediteurAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllExternCrediteurAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.externCreditures = action.payload;
        })
            .addCase(getAllExternCrediteurAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllCreditorsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllCreditorsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.creditors = action.payload;
            state.creditorDropdown = action.payload.map((creditor) => {
                return {
                    label: `${creditor.name}`,
                    value: creditor.id
                };
            });
            state.activeCreditorDropdown = action.payload
                .filter((x) => !x.expired)
                .map((creditor) => {
                return {
                    label: `${creditor.name}`,
                    value: creditor.id
                };
            });
        })
            .addCase(getAllCreditorsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getCreditureByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getCreditureByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.crediture = action.payload;
            state.unchangedCreditor = action.payload;
        })
            .addCase(getCreditureByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createContactPersonAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createContactPersonAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.contactPerson = action.payload;
        })
            .addCase(createContactPersonAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateContactPersonAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateContactPersonAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.updateContactPerson = action.payload;
        })
            .addCase(updateContactPersonAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteContactPersonByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteContactPersonByIdAsync.fulfilled, (state) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(deleteContactPersonByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getContactPersonsByCreditorIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getContactPersonsByCreditorIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.contactPersons = action.payload;
            state.creditureContactPersonDropdown = action.payload.map((contactperson) => {
                return {
                    label: `${contactperson.firstName ? contactperson.firstName : ''} ${contactperson.lastName ? contactperson.lastName : ''}`,
                    value: contactperson.id,
                    number: `${contactperson.phoneNumber ? contactperson.phoneNumber : ''}`
                };
            });
        })
            .addCase(getContactPersonsByCreditorIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getContactPersonbyIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getContactPersonbyIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.contactPersoon = action.payload;
        })
            .addCase(getContactPersonbyIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllAttachmentsByCreditorIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllAttachmentsByCreditorIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.creditureAttachments = action.payload;
        })
            .addCase(getAllAttachmentsByCreditorIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(addAttachmentsByCreditorIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(addAttachmentsByCreditorIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.uploadAttachment = action.payload;
        })
            .addCase(addAttachmentsByCreditorIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteCreditorAttachmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteCreditorAttachmentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.deleteAttachment = action.payload;
        })
            .addCase(deleteCreditorAttachmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteCreditureByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteCreditureByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.deleteCrediture = action.payload;
        })
            .addCase(deleteCreditureByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateCreditorToPreferenceAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateCreditorToPreferenceAsync.fulfilled, (state) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(updateCreditorToPreferenceAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default creditureSlice.reducer;
export const { clearSingleCrediture } = creditureSlice.actions;
